import React from "react";
import { useUser } from "../../../context/UserContext";
import { Download } from "lucide-react";
const TemplateProgressionNiveau = ({selectedNiveau}) => {
  
const { user} = useUser();
 const handleDownload = () => {
    // Préparer les en-têtes
    const headers = ["THEME", "TITRE SEQUENCE", "DUREE (semaines)"];
     
    // Déterminer si c'est un prof de français ou de maths
    const isFrancais = user?.matiere === 'Français';
     // Définir les thèmes selon la matière ET le niveau
    let themes = [];
    let progressionsData = [];
    
    if (isFrancais) {
      // Thèmes français
      if (selectedNiveau === "6eme") {
        themes = [
          "Langage Oral",
          "Lecture",
          "Écriture",
          "Vocabulaire",
          "Grammaire et orthographe grammaticale",
          "Culture littéraire et artistique"
        ];
        
        progressionsData = [
          ["Langage Oral", "Se présenter et présenter un livre", "1.5"],
          ["Lecture", "Contes et récits merveilleux", "3"],
          ["Écriture", "Écrire un conte", "2"],
          ["Vocabulaire", "Les familles de mots", "1"],
          ["Grammaire et orthographe grammaticale", "Les classes grammaticales", "2"],
          ["Culture littéraire et artistique", "L'Odyssée d'Homère", "3"],
          ["Lecture", "Récits d'aventures", "2.5"],
          ["Écriture", "Le récit d'aventure", "2"],
          ["Vocabulaire", "Le vocabulaire des émotions", "1"],
          ["Grammaire et orthographe grammaticale", "Les fonctions dans la phrase", "2"]
        ];
      } else {
        // Cycle 4 (5e, 4e, 3e)
        themes = [
          "Langage Oral",
          "Lecture et compréhension de l'écrit",
          "Écriture",
          "Étude de la langue",
          "Culture littéraire et artistique"
        ];
        
        if (selectedNiveau === "5eme") {
          progressionsData = [
            ["Lecture et compréhension de l'écrit", "Récits de chevalerie", "3"],
            ["Écriture", "Écrire une scène de combat épique", "2"],
            ["Étude de la langue", "Les temps du récit", "2"],
            ["Culture littéraire et artistique", "Le Roman de Renart", "2.5"],
            ["Langage Oral", "Réciter une scène de théâtre", "1.5"],
            ["Lecture et compréhension de l'écrit", "Récits de voyage", "2.5"],
            ["Étude de la langue", "L'accord du participe passé", "2"],
            ["Écriture", "Le carnet de voyage", "2"]
          ];
        } else if (selectedNiveau === "4eme") {
          progressionsData = [
            ["Lecture et compréhension de l'écrit", "La nouvelle réaliste", "3"],
            ["Culture littéraire et artistique", "Le romantisme", "2.5"],
            ["Écriture", "La description réaliste", "2"],
            ["Étude de la langue", "Les propositions subordonnées", "2"],
            ["Langage Oral", "Le débat argumenté", "1.5"],
            ["Lecture et compréhension de l'écrit", "La poésie lyrique", "2"],
            ["Étude de la langue", "Les valeurs des temps", "2"],
            ["Écriture", "Écrire une lettre", "1.5"]
          ];
        } else if (selectedNiveau === "3eme") {
          progressionsData = [
            ["Lecture et compréhension de l'écrit", "Récits autobiographiques", "3"],
            ["Culture littéraire et artistique", "Poésie engagée", "2.5"],
            ["Écriture", "L'argumentation", "3"],
            ["Étude de la langue", "Les paroles rapportées", "1.5"],
            ["Langage Oral", "L'oral du brevet", "2"],
            ["Lecture et compréhension de l'écrit", "Romans du XXe siècle", "3"],
            ["Étude de la langue", "Révisions grammaticales", "2"],
            ["Écriture", "Le sujet de réflexion", "2.5"]
          ];
        }
      }
    } else {
      // Thèmes maths (code existant)
      if (selectedNiveau === "6eme") {
        themes = [
          "Nombre, calcul et résolution de problèmes",
          "Initiation à la pensée informatique",
          "La proportionnalité",
          "Organisation et gestion de données et probabilités",
          "Espace et Géométrie",
          "Grandeurs et mesures"
        ];
        
        progressionsData = [
          ["Nombre, calcul et résolution de problèmes", "Nombres entiers et décimaux", "2"],
          ["Nombre, calcul et résolution de problèmes", "Opérations sur les nombres décimaux", "2.5"],
          ["Espace et Géométrie", "Bases de la géométrie", "1.5"],
          ["Nombre, calcul et résolution de problèmes", "Fractions - Notion de partage", "2"],
          ["Espace et Géométrie", "Droites perpendiculaires et parallèles", "1"],
          ["Grandeurs et mesures", "Périmètres et aires", "2"],
          ["La proportionnalité", "Situations de proportionnalité", "2"],
          ["Organisation et gestion de données et probabilités", "Tableaux et graphiques", "1.5"],
          ["Initiation à la pensée informatique", "Découverte de Scratch", "1"],
          ["Nombre, calcul et résolution de problèmes", "Problèmes complexes", "1.5"]
        ];
      } else if (selectedNiveau === "5eme") {
        // Cycle 4 rénové — 5e uniquement pour l'instant (4e/3e basculeront plus tard)
        themes = [
          "Espace et géométrie",
          "La pensée informatique",
          "Nombres et calculs",
          "Organisation et gestion de données et probabilités",
          "Proportionnalité, fonctions"
        ];

        progressionsData = [
          ["Nombres et calculs", "Nombres relatifs", "2.5"],
          ["Nombres et calculs", "Calcul littéral - Introduction", "2"],
          ["Espace et géométrie", "Symétrie centrale", "1.5"],
          ["Espace et géométrie", "Triangles", "2"],
          ["Proportionnalité, fonctions", "Situations de proportionnalité", "2"],
          ["Organisation et gestion de données et probabilités", "Tableaux et statistiques", "1.5"],
          ["La pensée informatique", "Boucles et conditions", "1.5"],
          ["Nombres et calculs", "Fractions - Opérations", "2"],
          ["Espace et géométrie", "Parallélogrammes", "1.5"]
        ];
      } else {
        // Ancien cycle 4 (4e, 3e)
        themes = [
          "Nombre et Calculs",
          "Espace et Géométrie",
          "Grandeurs et mesures",
          "Organisation et gestion de données, fonctions",
          "Algorithmique et programmation"
        ];

        if (selectedNiveau === "4eme") {
          progressionsData = [
            ["Nombre et Calculs", "Puissances", "2"],
            ["Nombre et Calculs", "Calcul littéral - Développement", "2.5"],
            ["Espace et Géométrie", "Théorème de Pythagore", "2"],
            ["Organisation et gestion de données, fonctions", "Notion de fonction", "2"],
            ["Espace et Géométrie", "Théorème de Thalès", "2"],
            ["Grandeurs et mesures", "Vitesse et grandeurs composées", "1.5"],
            ["Algorithmique et programmation", "Variables et fonctions", "2"],
            ["Organisation et gestion de données, fonctions", "Statistiques", "1.5"],
            ["Nombre et Calculs", "Équations", "2"]
          ];
        } else if (selectedNiveau === "3eme") {
          progressionsData = [
            ["Nombre et Calculs", "Racines carrées", "1.5"],
            ["Nombre et Calculs", "Factorisation et identités remarquables", "2.5"],
            ["Organisation et gestion de données, fonctions", "Fonctions affines", "2"],
            ["Espace et Géométrie", "Trigonométrie", "2"],
            ["Organisation et gestion de données, fonctions", "Probabilités", "2"],
            ["Espace et Géométrie", "Transformations et homothéties", "1.5"],
            ["Algorithmique et programmation", "Algorithmes avancés", "2"],
            ["Nombre et Calculs", "Inéquations et systèmes", "2"],
            ["Grandeurs et mesures", "Grandeurs composées et conversions", "1"],
            ["Organisation et gestion de données, fonctions", "Fonctions et graphiques", "2"]
          ];
        }
      }
    }
    
    // Créer le contenu CSV avec point-virgule comme séparateur
    let csvContent = headers.map(header => `"${header}"`).join(';') + '\n';
    
    // Ajouter les données
    progressionsData.forEach(row => {
      csvContent += row.map(cell => `"${cell}"`).join(';') + '\n';
    });
    
 
    // Ajouter le BOM UTF-8 pour la compatibilité Excel
    const BOM = '\uFEFF';
    const csvContentWithBOM = BOM + csvContent;
    
    // Créer un blob avec le contenu CSV
    const blob = new Blob([csvContentWithBOM], { 
      type: 'text/csv;charset=utf-8;' 
    });
    
    // Créer et déclencher le téléchargement
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `TemplateProgressions_${selectedNiveau}_avec_themes.csv`);
    link.style.visibility = 'hidden';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="mt-6 text-center">
      <button
        onClick={handleDownload}
        className="inline-flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700 transition-colors group"
      >
        <Download size={16} className="group-hover:-translate-y-0.5 transition-transform" />
        <span>Télécharger le modèle CSV</span>
      </button>
    </div>
  );
};

export default TemplateProgressionNiveau;